import { Controller } from "@hotwired/stimulus"

// Usage: put data-controller="eligible-staff-filter" on a <form> (or parent)
// and data-action="change->eligible-staff-filter#submit" on the role/skill/level
// <select multiple> elements (named eligible_filter[role_ids][], skill_ids[], levels[]).
// The form is expected to have data-eligible-staff-filter-url-value pointing to the
// eligible_staff endpoint; on change we fetch that URL with the current filter values
// and replace the #eligible_staff_panel turbo-frame with the response.
export default class extends Controller {
  static values = { url: String }

  submit(event) {
    const el = event.target
    const form = el.closest("form") || this.element
    const params = new URLSearchParams()

    this._appendMulti(params, form, "eligible_filter[role_ids][]", "role_ids[]")
    this._appendMulti(params, form, "eligible_filter[skill_ids][]", "skill_ids[]")
    this._appendMulti(params, form, "eligible_filter[levels][]", "levels[]")

    const frame = document.getElementById("eligible_staff_panel")
    if (frame && this.urlValue) {
      frame.src = `${this.urlValue}?${params.toString()}`
    }
  }

  _appendMulti(params, form, formName, paramName) {
    const nodes = form.querySelectorAll(`[name="${formName}"]`)
    nodes.forEach(node => {
      if (node.tagName === "SELECT" && node.multiple) {
        Array.from(node.selectedOptions).forEach(opt => {
          if (opt.value) params.append(paramName, opt.value)
        })
      } else if (node.value) {
        params.append(paramName, node.value)
      }
    })
  }
}
